var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2a1 1 0 100-2 1 1 0 000 2zm1 13.454V4H0v11.454L1 18l1-2.546z",
    fill: "#fff",
    fillOpacity: 0.4
  })));
}

export default SvgInfoSymbol;